import { render, staticRenderFns } from "./DisposeHoursRefillListBK.vue?vue&type=template&id=6b2a8273&"
import script from "./DisposeHoursRefillListBK.vue?vue&type=script&lang=js&"
export * from "./DisposeHoursRefillListBK.vue?vue&type=script&lang=js&"
import style0 from "./DisposeHoursRefillListBK.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports